import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

const paddingMap = {
  none: '',
  sm:   'p-4',
  md:   'p-5',
  lg:   'p-6',
};

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hoverable,
  padding = 'md',
  onClick,
}) => (
  <div
    onClick={onClick}
    className={`
      bg-v2-neutral-0 rounded-v2-lg border border-v2-neutral-200 overflow-hidden
      ${hoverable ? 'cursor-pointer transition-shadow duration-200 hover:shadow-md hover:-translate-y-0.5 transform' : ''}
      ${paddingMap[padding]}
      ${className}
    `}
  >
    {children}
  </div>
);

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}
export const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => (
  <div className={`px-5 py-3 border-b border-v2-neutral-100 ${className}`}>{children}</div>
);

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}
export const CardBody: React.FC<CardBodyProps> = ({ children, className = '' }) => (
  <div className={`p-5 ${className}`}>{children}</div>
);
